import { createSlice } from "@reduxjs/toolkit";
import { getAllActiveBlog, getBlogByURL } from "../services/blog.services";

export interface IBlogFAQ {
  ID: number;
  BlogID: number;
  Question: string;
  Answer: string;
  IsActive: boolean;
  SequenceNo: number;
}

export interface IBlogDetails {
  ID: number | null;
  BlogImage: string;
  BlogBannerImage: string;
  BlogTitle: string;
  BlogDate: string;
  ShortDescription: string;
  LongDescription: string;
  BlogURL: string;
  MetaTitle: string;
  MetaDescription: string;
  Keyword: string;
  BlogFAQList?: IBlogFAQ[];
}

export interface IBlog {
  ID: number | null;
  Title: string;
  BlogTitle: string;
  ShortDescription: string;
  BlogCategoryName: string;
  Keyword: string;
  Description: string;
  LongDescription: string;
  MetaTitle: string;
  MetaDescription: string;
  BlogDate: string;
  Image: string;
  BlogBannerImage: string;
  BlogURL: string;
  BlogFAQList?: IBlogFAQ[];
}

export interface IBlogInitialState {
  loading: boolean;
  error: string;
  blogDetails: IBlogDetails;
  BlogList: IBlog[];
}

const initialState: IBlogInitialState = {
  loading: false,
  error: "",
  blogDetails: {
    ID: null,
    BlogImage: "",
    BlogTitle: "",
    BlogDate: "",
    ShortDescription: "",
    LongDescription: "",
    BlogURL: "",
    MetaTitle: "",
    MetaDescription: "",
    Keyword: "",
    BlogBannerImage: "",
  },
  BlogList: [],
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveBlog.fulfilled, (state, action) => {
      state.loading = false;
      state.BlogList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveBlog.rejected, (state, action) => {
      state.loading = false;
      state.BlogList = initialState.BlogList;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBlogByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBlogByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.blogDetails = action.payload || [];
      state.error = "";
    });
    builder.addCase(getBlogByURL.rejected, (state, action) => {
      state.loading = false;
      state.blogDetails = initialState.blogDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default blogSlice.reducer;
